var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.device)?_c('hr-clock-device-helper',{staticClass:"ma-4 mb-0",attrs:{"device":_vm.device}}):_vm._e(),_c('edit',{attrs:{"modelDef":"hrclockdevices","id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }